// extracted by mini-css-extract-plugin
export var container = "_6w-0";
export var containerTopRight = "_6w-1";